import { User } from '../../../../store/types';
import { axiosInstance } from '../../axios';
import { LoginResponse } from './auth.interface';

export function login(token: string) {
  return axiosInstance
    .post<LoginResponse>('/api/auth/login', { token })
    .then((response) => response.data);
}

export function refreshTokens(refreshToken: string) {
  return axiosInstance
    .post<LoginResponse>('/api/auth/refresh-token', { refreshToken })
    .then((response) => response.data);
}

export function logout() {
  return axiosInstance
    .post<{ ok: true }>('/api/auth/logout')
    .then((response) => response.data);
}

export function fetchCurrentUser() {
  return axiosInstance.get<User>('/api/auth/me').then((response) => response.data);
}

export function regenerateAuthToken() {
  return axiosInstance
    .post<{ token: string }>('/api/auth/regenerate-token')
    .then((response) => response.data);
}

export function setContentfulPat(token: string) {
  return axiosInstance
    .post<{ ok: true }>('/api/auth/contentful-pat', { token })
    .then((response) => response.data);
}
